import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';

import React from 'react';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { DangerousGoodsCell } from './dangerous-goods-cell';
import { messages } from './messages';
import style from './styles.module.less';
import { useSimpleToggle } from '../../../hooks/use-simple-toggle';

const formatAmount = (dangerousGoodsAmount) => {
  const { unit, amount } = dangerousGoodsAmount;

  const value = [];
  if (typeof amount === 'number') {
    value.push(amount);
  }
  if (unit) {
    value.push(unit);
  }

  return value.join(' ');
};
/**
 * @typedef {import('react-table').UseExpandedRowProps} UseExpandedRowProps
 */

/**
 * @typedef {object} DangerousGoodsFormType
 * @property {string} [idNumber]
 * @property {string} [shippingName]
 * @property {string} [technicalName]
 * @property {string} [productClass]
 * @property {string} [productClassSubsidiary]
 * @property {string} [packagingType]
 * @property {number} [quantity]
 * @property {{ amount: number, unit: 'kg' | 'g' | "l" | "ml"}} [dangerousAmount]
 * @property {'i' | 'ii' | 'iii'} [packagingGroup]
 */

/**
 * Component for displaying dangerous goods details
 * @param {object} props
 * @param {{getToggleRowExpandedProps: UseExpandedRowProps, isExpanded: boolean, original: {itemName: {dangerousGoods: DangerousGoodsFormType[]}}}} props.item
 * @returns {JSX.Element}
 */
export const DangerousGoodsDetails = ({ item }) => {
  const [isExpanded, setIsExpanded] = useSimpleToggle(false);

  if (!item?.original?.itemName?.dangerousGoods?.length) {
    return null;
  }

  const dg = item.original.itemName?.dangerousGoods[0];

  return (
    <FlexRow className={style['items-table-sub-row-dangerous-goods']}>
      <FlexColumn>
        <div {...item.getToggleRowExpandedProps()} className={style['attribute-row-toggle']} onClick={setIsExpanded}>
          <FlexRow className={style.caret}>
            <FontAwesomeIcon icon={isExpanded ? faCaretDown : faCaretRight} />
          </FlexRow>
          <Text element='span' textType={TextType.Caption} value={messages.dangerousGoods} />
        </div>
        {isExpanded ? (
          <div className={style['dangerous-goods-row']}>
            <DangerousGoodsCell header={messages.unNumber} value={dg.idNumber} />
            <DangerousGoodsCell header={messages.shippingName} value={dg.shippingName} />
            <DangerousGoodsCell header={messages.technicalName} value={dg.technicalName} />
            <DangerousGoodsCell header={messages.productHazardClass} value={dg.productClass} />
            <DangerousGoodsCell header={messages.subHazard} value={dg.productClassSubsidiary} />
            <DangerousGoodsCell header={messages.amount} value={formatAmount(dg.dangerousAmount)} />
            <DangerousGoodsCell header={messages.quantity} value={dg.quantity} />
            <DangerousGoodsCell header={messages.packagingType} value={dg.packagingType} />
            <DangerousGoodsCell header={messages.packagingGroup} value={dg.packagingGroup} />
          </div>
        ) : null}
      </FlexColumn>
    </FlexRow>
  );
};
